import {
  SET_DARK_MODE,
  SET_TRACKING,
  SET_VOLUME,
  TOGGLE_AUTOPLAY,
} from 'spa/action_constants'

const defaultState = {
  autoplay: true,
  darkMode: true,
  volume: 1,
  trackingAllowed: false,
  trackingChecked: false,
}

export default function userPreferences(state = defaultState, action) {
  switch (action.type) {
    case SET_DARK_MODE:
      return {
        ...state,
        darkMode: !!action.value,
      }
    case SET_TRACKING:
      return {
        ...state,
        ...action.payload,
      }
    case SET_VOLUME:
      return {
        ...state,
        volume: action.payload,
      }
    case TOGGLE_AUTOPLAY:
      return {
        ...state,
        autoplay: !state.autoplay,
      }
    default:
      return state
  }
}
